var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6668 14.6666H15.6134L15.2401 14.3066C16.8401 12.44 17.6668 9.89331 17.2134 7.18665C16.5868 3.47998 13.4934 0.51998 9.7601 0.0666463C4.1201 -0.626687 -0.626565 4.11998 0.0667684 9.75998C0.520102 13.4933 3.4801 16.5866 7.18677 17.2133C9.89344 17.6666 12.4401 16.84 14.3068 15.24L14.6668 15.6133V16.6666L20.3334 22.3333C20.8801 22.88 21.7734 22.88 22.3201 22.3333C22.8668 21.7866 22.8668 20.8933 22.3201 20.3466L16.6668 14.6666ZM8.66677 14.6666C5.34677 14.6666 2.66677 11.9866 2.66677 8.66665C2.66677 5.34665 5.34677 2.66665 8.66677 2.66665C11.9868 2.66665 14.6668 5.34665 14.6668 8.66665C14.6668 11.9866 11.9868 14.6666 8.66677 14.6666Z",
    fill: "#2B8C34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchGreen);
export default __webpack_public_path__ + "static/media/search_green.aa3123db3e2f8f97aaa6146d7d39aafa.svg";
export { ForwardRef as ReactComponent };